import { Controller } from "@hotwired/stimulus"
import toast from "../services/toast"

export default class extends Controller {
  static targets = ["input", "preview", "previewImage", "uploadArea", "removeCheckbox", "removeContainer", "placeholder"]
  static values = {
    maxSize: { type: Number, default: 2097152 }, // 2MB en bytes
    hasExisting: { type: Boolean, default: false }
  }

  connect() {
    this.updateVisibility()
  }

  // Abrir selector de archivos al hacer clic en el área de upload
  openFileSelector() {
    this.inputTarget.click()
  }

  // Manejar selección de archivo
  handleFileSelect(event) {
    const file = event.target.files[0]
    if (!file) return

    // Validar tipo de archivo
    if (!file.type.startsWith("image/")) {
      this.showError("Por favor selecciona un archivo de imagen válido")
      this.clearInput()
      return
    }

    // Validar tamaño
    if (file.size > this.maxSizeValue) {
      const maxMB = (this.maxSizeValue / 1024 / 1024).toFixed(0)
      this.showError(`La imagen no debe exceder ${maxMB}MB`)
      this.clearInput()
      return
    }

    // Mostrar preview
    this.showPreview(file)
  }

  // Mostrar preview de la imagen seleccionada
  showPreview(file) {
    const reader = new FileReader()
    
    reader.onload = (e) => {
      this.previewImageTarget.src = e.target.result
      this.previewTarget.style.display = "block"
      
      if (this.hasUploadAreaTarget) {
        this.uploadAreaTarget.style.display = "none"
      }
      
      // Ocultar checkbox de eliminar existente si se selecciona nueva imagen
      if (this.hasRemoveContainerTarget) {
        this.removeContainerTarget.style.display = "none"
      }
    }
    
    reader.readAsDataURL(file)
  }

  // Eliminar la imagen seleccionada (nueva)
  removeNewImage(event) {
    event.preventDefault()
    event.stopPropagation()
    
    this.clearInput()
    this.previewTarget.style.display = "none"
    
    if (this.hasUploadAreaTarget) {
      this.uploadAreaTarget.style.display = "flex"
    }
    
    // Mostrar de nuevo el checkbox de eliminar si había imagen existente
    if (this.hasExistingValue && this.hasRemoveContainerTarget) {
      this.removeContainerTarget.style.display = "flex"
    }
  }

  // Limpiar el input de archivo
  clearInput() {
    this.inputTarget.value = ""
  }

  // Drag and drop handlers
  dragOver(event) {
    event.preventDefault()
    if (this.hasUploadAreaTarget) {
      this.uploadAreaTarget.classList.add("dragging")
    }
  }

  dragLeave(event) {
    event.preventDefault()
    if (this.hasUploadAreaTarget) {
      this.uploadAreaTarget.classList.remove("dragging")
    }
  }

  drop(event) {
    event.preventDefault()
    if (this.hasUploadAreaTarget) {
      this.uploadAreaTarget.classList.remove("dragging")
    }
    
    const file = event.dataTransfer.files[0]
    if (file) {
      // Asignar el archivo al input
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)
      this.inputTarget.files = dataTransfer.files
      
      // Disparar el evento change manualmente
      this.handleFileSelect({ target: { files: [file] } })
    }
  }

  // Mostrar mensaje de error
  showError(message) {
    toast.error(message)
  }

  // Actualizar visibilidad inicial
  updateVisibility() {
    // Si hay imagen existente, mostrar preview con la imagen existente
    // La lógica de visibilidad inicial se maneja en el template ERB
  }
}
